import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  content: PropTypes.node,
  cancelText: PropTypes.string,
  okText: PropTypes.string,
  onCancel: PropTypes.func,
  onProceed: PropTypes.func,
  confirmType: PropTypes.string,
};

const defaultProps = {
  title: 'Confirmation',
  visible: false,
  content: 'Your Content Modal here',
  cancelText: 'Cancel',
  okText: 'Ok',
  onCancel: () => {},
  onProceed: () => {},
  confirmType: '',
};

export default { propTypes, defaultProps };
